<template>
      <!-- Begin page -->
      <div id="wrapper">
            
            <topbar></topbar>
            <left></left>
            
            <div class="content-page">
                  <!-- Start content -->
                  <div class="content">
                        <div class="container-fluid">
                              
                              <div class="row">
                                    <div class="col-12">
                                          <div class="page-title-box">
                                                <h4 class="page-title float-left">认证专区</h4>
      
                                                <ol class="breadcrumb float-right">
                                                      <li class="breadcrumb-item"><a href="#">cpwm</a></li>
                                                      <li class="breadcrumb-item"><a href="#">认证专区</a></li>
                                                      <li class="breadcrumb-item active">首次认证</li>
                                                </ol>
                                                
                                                <div class="clearfix"></div>
                                          </div>
                                    </div>
                              </div>
                              <!-- end row -->
                              
                              
                              <div class="row">
                                    <div class="col-12">
                                          <div class="card-box">
                                                <h4 class="m-t-0 header-title" style="border-bottom: 1px solid #868686;padding-bottom: 10px;"><b style="font-size: 16px;margin-bottom: 10px;">第二步：信息认证</b></h4>
                                                <p class="text-muted m-b-30 font-14" style="color: #000000!important;line-height: 30px;">一、工作经历<br/>
                                                      <code>重要说明：2年以上（含2年）财富管理相关机构工作经验</code>
                                                </p>
                                                <div class="table-responsive">
                                                      <table class="table table-bordered table-striped">
                                                            <thead>
                                                            <tr>
                                                                  <th class="text-center">开始日期</th>
                                                                  <th class="text-center">结束日期</th>
                                                                  <th class="text-center">所在公司</th>
                                                                  <th class="text-center">证明人</th>
                                                                  <th class="text-center">证明人电话</th>
                                                                  <th class="text-center">操作</th>
                                                            
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            <tr v-for="item,index in jianli">
                                                                  <td>{{item.start_time}}</td>
                                                                  <td>{{item.over_time}}</td>
                                                                  <td>{{item.company}}</td>
                                                                  <td>{{item.references}}</td>
                                                                  <td>{{item.references_tel}}</td>
                                                                  <td><a href="javascript:void(0)" v-on:click="jianli_del(index)">删除</a></td>
                                                            </tr>
                                                            <tr style="background-color: #ffffff;">
                                                                  <td><input type="text" style="width:100%;height:100%;border:0px;" v-model="start_time" id="start_time"></td>
                                                                  <td><input type="text" style="width:100%;height:100%;border:0px;" v-model="over_time" id="over_time"></td>
                                                                  <td><input type="text" style="width:100%;height:100%;border:0px;" v-model="company"></td>
                                                                  <td><input type="text" style="width:100%;height:100%;border:0px;" v-model="references"></td>
                                                                  <td><input type="text" style="width:100%;height:100%;border:0px;" v-model="references_tel"></td>
                                                                  <td></td>
                                                            </tr>
                                                            
                                                            
                                                            
                                                            </tbody>
                                                      </table>
                                                </div>
                                                
                                                <div style="width: 100%;float:left;padding:20px;text-align: right;">
                                                      <button type="submit" style="margin: 0 auto;" class="btn btn-gradient btn-rounded waves-light waves-effect w-md"  v-on:click="jianli_add">+增加</button>
                                                </div>
                                                <div>
                                                      {{showdata}}
                                                </div>
                                                <div style="width: 100%;float:left;padding:20px;text-align: right;">
                                                      <button type="submit" style="margin: 0 auto;" class="btn btn-gradient btn-rounded waves-light waves-effect w-md"  v-on:click="add">提交申请</button>
                                                </div>
                                                <div style="clear: both"></div>
                                                <!-- end row -->
                                          
                                          </div> <!-- end card-box -->
                                    </div><!-- end col -->
                              </div>
                              <!-- end row -->
                        
                        
                        </div> <!-- container -->
                  
                  </div> <!-- content -->
      
                  <!--footer-->
            
            </div>
      
      </div>


</template>

<script>
      import topbar from './topbar';
      import left from './left';
      import UploadFile from "./UploadFile";
      import UploadFile_more from "./UploadFile_more";

      export default {
            components: {topbar,left,UploadFile,UploadFile_more},
            data() {
                  return {
                        jianli:this.jianli,
                        shouru:this.shouru,
                        shouru_images:this.shouru_images,

                        start_time:this.start_time,
                        over_time:this.over_time,
                        company:this.company,
                        references:this.references,
                        references_tel:this.references_tel,

                        uploadnum:1, //上传数量

                        showdata:this.showdata,
                  }
            },
            created() {
                  this.jianli = [];
                  //时间日期
                  layui.use('laydate', function() {
                        var laydate = layui.laydate;
                        laydate.render({
                              elem: '#start_time' //指定元素
                              ,type: 'date'
                              ,theme: 'molv'
                              //,value: ''
                              ,isInitValue: true
                              //,range: true
                              ,trigger: 'click',
                              done: value =>{
                                    this.start_time=value;
                                    console.log(this.start_time);
                              }

                        });

                        laydate.render({
                              elem: '#over_time' //指定元素
                              ,type: 'date'
                              ,theme: 'molv'
                              //,value: ''
                              ,isInitValue: true
                              //,range: true
                              ,trigger: 'click',
                              done: value =>{
                                    this.over_time=value;
                                    console.log(this.over_time);
                              }
                        });
                  }.bind(this));
               
            },
            methods: {
                  jianli_add:function(){
                        if(this.start_time!=undefined && this.over_time!=undefined && this.company!=undefined && this.references!=undefined && this.references_tel!=undefined){
                              this.jianli.push({"start_time": this.start_time, "over_time": this.over_time, "company": this.company, "references": this.references, "references_tel": this.references_tel});
                              this.start_time='';
                              this.over_time='';
                              this.company='';
                              this.references='';
                              this.references_tel='';
                        }else{
                              swal(
                                    {
                                          title: '简历请填写完全',
                                          text: 'CPWM',
                                          type: 'error',
                                          confirmButtonColor: '#4fa7f3',
                                    }
                              )
                        }
                        
                       
                  },
                  add: function () {
                        
                       
                        if(this.jianli.length==0){
                              swal(
                                    {
                                          title: '请填写工作经历',
                                          text: 'CPWM',
                                          type: 'error',
                                          confirmButtonColor: '#4fa7f3',
                                    }
                              )
                              return false;
                        }
                        let data = {
                              jianli: this.jianli,
                              shouru: this.shouru,
                              shouru_images:this.shouru_images,
                        }
                        this.$axios({
                              method: "POST",
                              url: '/api/member2/Authentication_add_showdata',
                              data: data,
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {
                                   this.showdata=response.data;

                        }.bind(this)).catch(function OnError() {

                        })

                  },
                  Authentication_show: function () {
                       
                        this.$axios({
                              method: "get",
                              url: '/api/member2/Authentication_show',
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {
                              this.jianli=response.data.jianli;
                              this.shouru=response.data.shouru;
                              this.shouru_images=response.data.shouru_images;
                        }.bind(this)).catch(function OnError() {

                        })

                  },
                  jianli_del:function(index){
                        this.jianli.splice(index,1);
                        //console.log(index)
                  },
                  /*
                  fimage(url){
                        this.shouru_images=url;
                  },
                 
                   */
                  fimgurl(url){
                        this.uploadnum=this.uploadnum+1;
                        this.shouru_images=url+','+this.shouru_images;
                        //console.log(this.shouru_images);
                  },
                  getimg: function (url) {
                        this.shouru_images = url;
                  },
                  //method over

            }
            //mounted over


      }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
      .zx {
            width: 100%;
      }
      
      .zx li {
            width: 100%;
            float: left
      }


</style>



// WEBPACK FOOTER //
// src/components/Authentication_step2_showdata.vue